export default value => {
  const statuses = {
    null: 'Waiting for validation',
    master_card: 'Mastercard',
    visa: 'Visa',
  };
  return statuses[value] || value;
};
